// extracted by mini-css-extract-plugin
module.exports = {"mapControls":"MapControl--mapControls"};